import { forwardRef } from "react";
import styles from "./Bar.module.css";

interface Props {
  show: boolean;
  zIndex: number;
  color?: string;
  offset?: number;
  width?: number;
  children?: React.ReactNode;
}

const fixNaN = (value: number) => (isNaN(value) ? 0 : value ?? 0);
export const Bar = forwardRef<HTMLDivElement, Props>(
  ({ show, zIndex, color, offset = 0, width, children }: Props, ref) => {
    const containerStyle = {
      zIndex,
      opacity: show ? 1 : 0,
    };

    const barStyle = {
      background: color,
      left: fixNaN(offset),
      width: width === undefined ? "100%" : fixNaN(width),
    };

    return (
      <div style={containerStyle} className={styles.container}>
        <div ref={ref} style={barStyle} className={styles.bar}>
          {children}
        </div>
      </div>
    );
  }
);
